export class Report {
  key:number;
  date:string;
  user:string;
  url:string;
  type:string;
}

export const ReportTypes = {
  PAGE_POSITION: 'PagePositionalReport',
  PAGE_ITEM_LIST: 'PageItemListReport'  
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/report.ts